import React from "react";
import Header from "../Components/header";
import StudentHeader from "../Components/studentHeader";
import { Route, Routes } from "react-router-dom";
import StudentDashboard from "../Pages/Student/StudentDashboard";
import Footer from "../Components/Footer";

export function StudentLayout(){
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <StudentHeader />
            <section className="flex-1 container px-4 md:px-0 mx-auto">
                <Routes>
                    <Route path="/" element={<StudentDashboard />} />
                </Routes>
            </section>
            <Footer />
        </div>
    );
}